<template>
    <LoginRedirect :currentStep="currentStep" :allDone="allDone" />
</template>

<script>
import LoginRedirect from '../../../components/LoginRedirect';

export default {
    components: { LoginRedirect },
    data() {
        return {
            currentStep: 0,
            allDone: false
        };
    },
    async created() {
        try {
            // Step 0: Authenticating
            const result = await window.auth.loginCallback();

            let returnToUrl = '/';

            if (result.state !== undefined) {
                if (!result.state.startsWith('/login'))
                    returnToUrl = result.state;
            } else {
                this.$root.isAuthenticated = true;
            }

            // Step 1: Loading your workspace
            this.currentStep = 1;

            if (localStorage.getItem('invitationUrl') != null) {
                returnToUrl = localStorage.getItem('invitationUrl');
                localStorage.removeItem('invitationUrl');
                this.currentStep = 2;
                this.allDone = true;
                this.$router.push({ path: returnToUrl });
            } else {
                await this.$store.dispatch('team/FETCH_TEAM_MEMBERS');

                // Step 2: Preparing routes
                this.currentStep = 2;

                const response = await this.$store.dispatch('user/FETCH_USER');

                this.allDone = true;

                if (!response.hasTeam) {
                    this.$router.push({ path: '/team/profile' });
                    return;
                }

                if (
                    (response.onboardingSettings == null ||
                        (response.onboardingSettings != null && !response.onboardingSettings.isSkipped)) &&
                    returnToUrl === '/'
                ) {
                    this.$router.push({ path: '/support/onboarding' });
                } else {
                    this.$router.push({ path: returnToUrl });
                }
            }
        } catch (e) {
            console.error('Login callback failed:', e);
            // Re-enter through the app root, not /login: the guard restarts sign-in with the
            // enterprise-SSO slug intact, whereas /login is the generic reset (CORE-7425).
            this.$router.push({ path: '/' });
        }
    }
};
</script>
